module.exports = __webpack_public_path__ + "static/img/zhhq-hqfwzx-01.114eeae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zhhq-hqfwzx-01.png
// module id = P/Zm
// module chunks = 1